document.addEventListener("DOMContentLoaded", function () {

    const menuLinks = document.querySelectorAll(".nav-link");
    const overlay = document.querySelector(".menu-overlay");
    const checkbox = document.getElementById("check");

    const topBar = document.querySelector(".rh-header__top");
    const bottomBar = document.querySelector(".rh-header__bottom");
    const nav = document.querySelector(".rh-header__nav");
    const placeholder = document.querySelector(".rh-header-placeholder");

    // Mobile dropdown
    document.querySelectorAll(".submenu-toggle").forEach(toggle => {

        toggle.addEventListener("click", function (e) {

            if (window.innerWidth >= 992) return;

            e.preventDefault();
            e.stopPropagation();

            const parent = this.closest(".nav-link");

            parent.classList.toggle("active");

        });

    });

    // Close menu
    overlay.addEventListener("click", function () {

        checkbox.checked = false;
        toggleBodyScroll();
        menuLinks.forEach(item => item.classList.remove("active"));

    });

    const closeBtn = document.querySelector(".menu-close");

    closeBtn.addEventListener("click", function () {

        checkbox.checked = false;
        toggleBodyScroll();
        menuLinks.forEach(item => {
            item.classList.remove("active");
        });

    });
    function updateMenuPosition() {

        if (window.innerWidth < 992) {

            nav.style.top = "0";
            nav.style.height = "100vh";

        } else {

            nav.style.top = "";
            nav.style.height = "";

        }

    }
    function toggleBodyScroll() {
        document.body.classList.toggle("menu-open", checkbox.checked);
    }
    checkbox.addEventListener("change", function () {
        toggleBodyScroll();
    });
    function stickyHeader() {

        if (window.scrollY > topBar.offsetHeight) {

            bottomBar.classList.add("is-sticky");
            placeholder.style.height = bottomBar.offsetHeight + "px";

        } else {

            bottomBar.classList.remove("is-sticky");
            placeholder.style.height = 0;

        }

        updateMenuPosition();

    }

    stickyHeader();

    window.addEventListener("scroll", stickyHeader);
    window.addEventListener("resize", () => {

        stickyHeader();

    });
});